var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 200,
    fill: "#DC2626"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 50L200 150H0L100 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 150,
    width: 120,
    height: 100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 170,
    width: 30,
    height: 30,
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 170,
    width: 30,
    height: 30,
    fill: "#DC2626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f2ef4f47dfeca22ae58bea56e3684727.svg";
export { ForwardRef as ReactComponent };